<template>
  <div :class="margins">
    <slot></slot>
    <!-- :class="{'pr-1': $vuetify.breakpoint.sAndDown, 'pr-5': $vuetify.breakpoint.smAndUp}" -->
  </div>
</template>

<script>
  export default {
    name: 'GatFieldSpacer',
    props:['size'],
    computed:{
      margins(){

        let result = "mr-3 ml-3";
        //if phone
        if (this.$vuetify.breakpoint.xsOnly){
           result = "mr-2 ml-2";

        }
        return result;
      }
    },

    }
</script>

<style scoped>

</style>
